import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=0b2eeff0&"
import script from "./ClientDashboard.vue?vue&type=script&lang=ts&"
export * from "./ClientDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports